/*
    Scraped from:
        https://quizlet.com/4776451/100-most-frequent-german-adjectives-flash-cards/

    Manual cleansing is visible by commented-out code
*/

/*
    Manual scraping code (enter in the browser console)
    ====================

    NodeList.prototype.map = Array.prototype.map;

    JSON.stringify(document.querySelectorAll('.term').map((node) => {
      const adj = node.querySelector('.word').innerText;
      const def = node.querySelector('.definition').innerText;
      return [adj, def.split(', ')]
    }))
*/


export default [
    ["ganz",    [0], [
        "whole",
        // "all the"
    ]],
    ["groß",    [0], ["big", "large", "great"]],
    ["gut",     [0], ["good"]],
    ["neu",     [0], ["new"]],
    ["erst",    [0], ["first"]],
    ["zweit",   [0], ["second"]],
    ["lang",    [0], ["long"]],
    ["deutsch",     [0], ["German"]],
    ["klein",   [0], ["small", "little"]],
    ["alt",     [0], ["old"]],
    ["hoch",    [0], ["high", "tall"]],
    ["einfach",     [0], ["simple", "easy"]],
    ["letzt",   [0], ["last"]],
    ["gleich",  [0], ["same", "right away", "just"]],
    ["möglich",     [0], ["possible", "potential", "feasible"]],
    ["eigen",   [0], ["own", "particular", "innate"]],
    ["schön",   [0], ["beautiful", "good", "pleasant"]],
    ["spät",    [0], ["late"]],
    ["wichtig",     [0], ["important", "fundamental", "grave"]],
    ["weit",  [0], ["wide", "long", "broad"]],
    ["weiter",  [0], ["additional", "other"]],
    // ["genau",    [0], ["exactly"]],
    ["jung",    [0], ["young"]],
    ["kurz",    [0], ["short"]],
    ["stark",   [0], ["strong"]],
    ["richtig", [0], ["correct", "proper"]],
    ["verschieden", [0], ["different", "diverse"]],
    ["bestimmt",[0], ["special", "certain", "particular"]],
    ["besser",  [0], ["better"]],
    ["schnell",     [0], ["fast"]],
    ["sicher",  [0], ["safe", "secure", "certain"]],
    ["nächst",  [0], ["next"]],
    ["politisch",   [0], ["political"]],
    ["klar",    [0], ["clear"]],
    ["schwer",  [0], ["difficult", "heavy", "hard"]],
    ["einzeln", [0], ["individual", "particular", "unique"]],
    ["bekannt", [0], ["well-known"]],
    ["leicht",  [0], ["light", "easy"]],
    ["rund",    [0], ["round"]],
    ["frei",    [0], ["free"]],
    ["früh",    [0], ["early"]],
    ["unterschiedlich",     [0], ["different", "variable"]],
    ["schlecht",    [0], ["bad"]],
    ["deutlich",    [0], ["clear", "explicit", "obvious"]],
    ["allgemein",   [0], ["general", "universal", "global"]],
    ["einzig",      [0], ["only", "single"]],
    ["gemeinsam",   [0], ["common", "mutual", "joint"]],
    ["nah",     [0], ["near", "close"]],
    ["voll",    [0], ["full"]],
    ["direkt",  [0], ["direct", "straight"]],
    ["international",   [0], ["international"]],
    ["sozial",  [0], ["social"]],
    ["best",    [0], ["best"]],
    ["rot",     [0], ["red"]],
    ["offen",   [0], ["open"]],
    // ["meist",   [0], ["most"]],
    ["besonder",[0], ["special", "specific"]],
    ["gewiss",  [0], ["certain", "assured"]],
    ["öffentlich",  [0], ["public"]],
    ["wahrscheinlich",  [0], ["probable", "likely"]],
    ["europäisch",  [0], ["European"]],
    ["wesentlich",  [0], ["essential", "substantial", "fundamental"]],
    ["ähnlich",     [0], ["similar", "related"]],
    ["häufig",  [0], ["frequent", "usual"]],
    ["schwarz",     [0], ["black"]],
    ["völlig",  [0], ["complete", "absolute"]],
    ["gering",  [0], ["small", "low", "slight"]],
    ["schwierig",   [0], ["difficult", "challenging", "complex"]],
    ["praktisch",   [0], ["practical"]],
    ["persönlich",  [0], ["personal"]],
    // ["-jährig", ["years (old)"]],
    ["modern",  [0], ["modern"]],
    ["tief",    [0], ["deep"]],
    ["tatsächlich",     [0], ["real", "actual"]],
    ["zusätzlich",  [0], ["additional", "extra"]],
    ["amerikanisch",    [0], ["American"]],
    ["wirtschaftlich",  [0], ["economic", "financial"]],
    ["interessant",     [0], ["interesting"]],
    ["relativ",     [0], ["relative", "comparative"]],
    ["gleichzeitig",    [0], ["simultaneous", "concurrent"]],
    ["grün",    [0], ["green"]],
    ["weiß",    [0], ["white"]],
    ["gesamt",  [0], ["whole", "entire", "collective"]],
    ["speziell",    [0], ["special", "specific"]],
    ["entscheidend",    [0], ["decisive", "pivotal", "critical"]],
    ["eng",     [0], ["narrow", "close"]],
    ["technisch",   [0], ["technical"]],
    ["langsam",     [0], ["slow"]],
    ["ständig",     [0], ["constant", "steady", "permanent"]],
    ["wendig",   [0], ["agile", "flexible", "versatile"]],
    ["notwendig",   [0], ["necessary", "essential", "requisite"]],
    ["rein",    [0], ["pure", "clean", "clear"]],
    ["englisch",    [0], ["English"]],
    ["wissenschaftlich",    [0], ["scientific", "scholarly"]],
    ["falsch",  [0], ["false", "wrong"]],
    ["fremd",   [0], ["foreign", "strange"]],
    ["französisch",     [0], ["French"]],
    ["selten",  [0], ["rare", "uncommon"]],
    ["normal",  [0], ["normal"]],
    ["wahr",    [0], ["true", "real"]],
    ["privat",  [0], ["private"]],
    ["tot",     [0], ["dead"]],
    ["halb",    [0], ["half"]]
];